import { AutogenModelManifestMovementOrder, AutogenRowManifestMovementOrder } from "./autogen/AutogenModelManifestMovementOrder";

export class ModelManifestMovementOrder extends AutogenModelManifestMovementOrder<RowManifestMovementOrder> {
	constructor() {
		super(RowManifestMovementOrder);
	}
}

export class RowManifestMovementOrder extends AutogenRowManifestMovementOrder {
}